import axios from 'axios';

export default {
  namespaced: true,
  state: {
    newClientDialog: undefined,
    indexProjectImported: undefined,
    newProjectsCreated: [],
  },
  getters: {
  },
  mutations: {
    setNewClientDialog(state, value) {
      state.newClientDialog = value;
    },
    setIndexProjectImported(state, value) {
      state.indexProjectImported = value;
    },
    setNewProjectsCreated(state, value) {
      const newValues = [];
      value.forEach((project) => {
        const projectUpdated = project;
        if (project.name.startsWith('05') || project.name.startsWith('15')) projectUpdated.projectCreatorType = 'Non-Restaurant Project';
        else if (project.name.startsWith('10')) projectUpdated.projectCreatorType = 'International Project';
        else if (!project.name.startsWith('00')
          && project.name.split('_').length >= 5
          && !project.name.includes('VOID')) projectUpdated.projectCreatorType = 'Restaurant Project';
        else projectUpdated.projectCreatorType = 'Unknown type';

        if (projectUpdated.projectCreatorType) newValues.push(projectUpdated);
      });
      state.newProjectsCreated = newValues;
    },
  },
  actions: {
    async createProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/projects-creator', data.project, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async addMembersToProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post(`/projects-creator/${data.project_id}/members`, data.members, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async createFolderStructureToProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post(`/projects-creator/${data.project_id}/structure`, { type: data.type }, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveFolderStructureToProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.get(`/projects-creator/${data.project_id}/structure`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async collaborateModelsTemplateToProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post(`/projects-creator/${data.project_id}/collaborate`, { project: data.project, templates: data.templates, user_logged_in: data.user_logged_in }, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveQueueModelByProject(context, projectId) {
      try {
        const config = { withCredentials: true };
        const response = await axios.get(`/projects-creator/${projectId}/collaborate`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async tryAgainModelByProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/projects-creator/${data.projectId}/collaborate/${data.modelId}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
